"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.background"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ImageCard = function ImageCard(_ref) {
  var LoadingContent = _ref.LoadingContent,
      children = _ref.children,
      to = _ref.to,
      width = _ref.width,
      height = _ref.height,
      imgUrl = _ref.imgUrl,
      as = _ref.as,
      menu = _ref.menu,
      _ref$placeholderLoadi = _ref.placeholderLoading,
      placeholderLoading = _ref$placeholderLoadi === void 0 ? false : _ref$placeholderLoadi,
      highlight = _ref.highlight;
  return _react["default"].createElement(_styled.CardContainer, {
    width: width,
    height: height,
    as: as,
    to: to,
    placeholderLoading: placeholderLoading
  }, _react["default"].createElement(_styled.Card, {
    highlight: highlight
  }, highlight && _react["default"].createElement(_styled.HighlightWave, null), _react["default"].createElement(_styled.Highlight, {
    shown: highlight
  }), _react["default"].createElement(_styled.BgContainer, null, placeholderLoading || imgUrl ? _react["default"].createElement(_knotchincWebReactComponents["default"], {
    color: placeholderLoading ? 'transparent' : null,
    url: imgUrl,
    opacity: "0"
  }) : _react["default"].createElement(_styled.CardBg, null), _react["default"].createElement(_styled.CardOverlay, {
    placeholderLoading: placeholderLoading
  }), _react["default"].createElement(_styled.CardHoverOverlay, null)), menu), _react["default"].createElement(_styled.CardContentContainer, {
    placeholderLoading: placeholderLoading
  }, LoadingContent ? _react["default"].createElement(LoadingContent, null) : null, _react["default"].createElement(_styled.LoadedContentContainer, null, children)));
};

var _default = ImageCard;
exports["default"] = _default;

//# sourceMappingURL=ImageCard.js.map